export const GiftCardsTerms = {
    data() {
        return {
            terms: {
                id: null,
                name: '',
                url: '',
                description: '',
            },
        }
    },
   /* mounted() {
        window.axios
            .get('/gift-cards/config/terms')
            .then(({ data }) => {
                this.terms = data.body.terms.find((term) => term.id === this.$route.params.id);
            });
    }*/
}
